const keys = {
  continuouslyCoverage: {
    titles: {
      currentCarrier: 'Who is your current {{0}} insurer?',
      yearsInsuredWith: 'How long have you been insured with {{0}} for {{1}} insurance?',
      renewalMonth: 'Which month does your current policy with {{0}} end?',
      uninsuredReason: 'Please, tell us the reason you are currently not insured?',
    },
    placeholders: {
      currentCarrier: 'ex. Desjardins',
      renewalMonth: 'ex. July',
      uninsuredReason: 'Reason',
    },
    suffix: {
      currentCarrier: 'your current insurer',
    },
  },
};

export default keys;

export type TranslationKeys = typeof keys;
